import { orderFormFieldsFragment } from 'apollo/fragments';
import { restorationDataFragment } from 'apollo/fragments';

import { gql } from 'graphql.macro';

export const orderFormsTemplate = gql`
    query orderForms($status: OrderFormStatus, $search: String, $limit: Int, $offset: Int) {
        orderForms(status: $status, search: $search, limit: $limit, offset: $offset) {
            _id
            title
            status
            createdAt
            createdBy {
                name {
                    firstName
                    lastName
                }
                fullName
            }
        }
    }
`;

export const orderFormTemplate = gql`
    query orderForm($_id: MongoDbObjectId!) {
        orderForm(_id: $_id) {
            _id
            title
            status
            createdAt
            imageUrl
            imageRotation
            createdBy {
                name {
                    firstName
                    lastName
                }
                fullName
            }
            formFields {
                ...orderFormFields
            }
            restorationData {
                ...restorationDataFields
            }
            deliveryDate
            deliveryTime {
                hour
                minute
            }
        }
    }
    ${orderFormFieldsFragment}
    ${restorationDataFragment}
`;
